






















import { Component, Vue, Emit } from "vue-property-decorator";
@Component
export default class AddAssetCard extends Vue {
  @Emit()
  clicked() {
    return true;
  }
}
